module.exports = __webpack_public_path__ + "static/media/unlock-alt.4ee9a747.svg";